module.exports = __webpack_public_path__ + "static/media/bbb-content.591f251f.jpg";